<div class="main">
  <!-- Do not mount the QSP web component locally, where its unavailable API can continuously retry. -->
  @if (!isLoading && surveyId && !isLocalSurveyBypass) {
    <wm-fill-survey style="width: 100%" [surveyId]="surveyId" preview-mode="false" state="closed" (submitResults)="submitResults($event.detail)">
      </wm-fill-survey
      >
    }
    @if (isLoading) {
      <div class="d-flex justify-content-center align-items-center w-100 h-100">
        <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    }
  </div>
